import React from 'react'
import { connect } from 'react-redux'
import classes from './styles.module.scss'
import { Button, Drawer, Select, Input, Typography, Spin, Icon, Form } from 'antd'
import { recordCountlyEvent, intl } from 'utils'
import messages from './messages'
import { Flex } from 'antd-mobile'
import { WhiteSpace } from 'components'
import QRCodeManager from 'qrcode.react'
import { mobileRule, uaeMobileRule } from 'utils/validateRules'
import ErrorPrompt from './ErrorPrompt'

const ICONS = {
  IconLogo: require('./images/icon-logo.svg'),
  IconProcessTitle: require('./images/icon-process-title.svg'),
  IconArrowDown: require('./images/icon-arrow-down.svg'),
  IconFlag: require('./images/icon-ae.svg')
}

const IMAGES = {
  ImageLogoPc: require('./images/image-logo-pc.png'),
  ImageLogoMobile: require('./images/image-logo-mobile.png'),
  ImageCode: require('./images/image-code.png'),
  ImageFaild: require('./images/failed.png')
}
class AaniPay extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isCalledDeeplink: false,
      visible: false,
      mobileNumber: '',
      scanPayUrl: '',
      isErr: false
    }
  }

  handleOpenDrawer = () => {
    this.setState({
      visible: true
    })
  }

  handleNext = () => {
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { submit, pageName, siteConfig, ...data } = this.props
        this.setState({
          visible: false
        })

        pageName &&
        recordCountlyEvent({
          page_name: pageName,
          event_name: 'pull',
          element_name: 'pull_pay',
          biz_tags: {
            channel: data.tabName.toLowerCase().replace(' ', '_'),
            trade_voucher_no: sessionStorage.orderNo,
          },
        })
        setTimeout(() => {
          this.setState({ isCalledDeeplink: true })
        }, 500)
        const countryItem = siteConfig.allowedCountries.list.find(
          item => item.countryCode === values.country
        )

        const fullMobileNo = `${countryItem.areaCode}${values.phone}`
        const datas = {
          orderToken: siteConfig.orderToken,
          payMethodShortNo: data.item.payMethod.payMethodShortNo,
          payAmount: {
            amount: siteConfig.payInfo.payAmount.amount,
            currency: siteConfig.payInfo.payAmount.currency
          },
          aaniInfo: {
            txnType: 'rtp',
            mobileNo: fullMobileNo
          }
        }
        this.props.actions.unauthConfirmPay(datas, (err, res) => {
          if (!err && res.request === 'success') {
            submit({
              ...data,
              orderNo: siteConfig.orderNo,
              orderToken: siteConfig.orderToken,
              deepLink: res.paymentExtension.DEEP_LINK,
              method: 'PAY_WITH_AANI',
            })
          }
        })
      }
    })
  };

  componentDidMount() {
    const { siteConfig, item } = this.props
    if (siteConfig.isMobile) return
    const data = {
      orderToken: siteConfig.orderToken,
      payMethodShortNo: item.payMethod.payMethodShortNo,
      payAmount: {
        amount: siteConfig.payInfo.payAmount.amount,
        currency: siteConfig.payInfo.payAmount.currency
      },
      devicePayInfo: {
        paymentToken: siteConfig.orderToken,
        decryptType: 'Merchant Decrypt'
      },
      aaniInfo: {
        txnType: 'qr-code'
      }
    }
    this.props.actions.unauthConfirmPay(data, (err, res) => {
      if (!err && res.request === 'success') {
        this.setState({
          scanPayUrl: res.paymentExtension.QR_CODE,
          isErr: false
        })
      } else {
        this.setState({ isErr: true })
      }
    })
  }

  retryGetQR = () => {
    const { siteConfig, item } = this.props
    if (siteConfig.isMobile) return
    const data = {
      orderToken: siteConfig.orderToken,
      payMethodShortNo: item.payMethod.payMethodShortNo,
      payAmount: {
        amount: siteConfig.payInfo.payAmount.amount,
        currency: siteConfig.payInfo.payAmount.currency
      },
      devicePayInfo: {
        paymentToken: siteConfig.orderToken,
        decryptType: 'Merchant Decrypt'
      },
      aaniInfo: {
        txnType: 'qr-code'
      }
    }
    this.props.actions.unauthConfirmPay(data, (err, res) => {
      if (!err && res.request === 'success') {
        this.setState({
          scanPayUrl: res.paymentExtension.QR_CODE,
          isErr: false
        })
      } else {
        this.setState({ isErr: true })
      }
    })
  }

  render() {
    const {
      siteConfig,
      pageName,
      form
    } = this.props

    const { visible, isCalledDeeplink, scanPayUrl, isErr } = this.state
    const { getFieldDecorator } = this.props.form

    const prefixSelector = getFieldDecorator('country', {
      initialValue: siteConfig && siteConfig.allowedCountries.list.find(item => item.areaCode === '+971').countryCode,
    })(
      <Select
        suffixIcon={<img src={ICONS.IconArrowDown} />}
      >
        {siteConfig.allowedCountries.list.map((d) => (
          <Select.Option
            key={d.countryCode}
            value={d.countryCode}
          >
            <Flex justify='flex-start' align='center'>
              <Typography.Text>
                {d.areaCode}
              </Typography.Text>
            </Flex>
          </Select.Option>
        ))}
      </Select>,
    )
    if (siteConfig.isMobile) {
      return (
        <div className={classes.componentsPaymentMethodsAaniPay}>
          {!visible && (
            <Button
              block
              loading={visible}
              type='default'
              size='large'
              style={{ borderColor: 'var(--gray-7)', backgroundColor: 'var(--gray-1)' }}
              onClick={this.handleOpenDrawer}
              className={classes.mobileSelectBtn}
            >
              <img src={IMAGES.ImageLogoMobile} className={classes.imageLogoMobile} />
                  Aani
            </Button>
          )}
          <Drawer
            visible={visible}
            closable={false}
            height='100vh'
            width='100vw'
            placement='right'
            className={classes.anniPayLoginDrawer}
          >
            <Flex direction='column' className='w-full h-full justify-center'>
              <WhiteSpace size='sm' />
              <div className='clearfix w-full flex justify-start'>
                <span
                  className='icon iconfont fill_icon iconarrow-long font-20'
                  onClick={() => this.setState({ visible: false })}
                />
              </div>
              <div className={classes.anniLogoBox}>
                <img src={ICONS.IconLogo} />
              </div>
              <div className={classes.anniProcessBox}>
                <img src={ICONS.IconProcessTitle} />
              </div>
              <div className={classes.loginLabel}>
                <span>Please input your phone number</span>
              </div>
              <Form onSubmit={this.handleSubmit} className={`${classes.anniPhoneBox} ${siteConfig.language === 'ar' ? classes.anniArPhoneBox : ''}`}>
                <Form.Item>
                  {form.getFieldDecorator('phone', {
                    ...(form.getFieldValue('country') === 'AE' ? uaeMobileRule() : mobileRule()),
                    validateTrigger: 'onChange'
                  })(<Input addonBefore={prefixSelector} style={{ width: '100%' }} />)}
                </Form.Item>
                <Form.Item>
                  <Button className={classes.nextBtn} htmlType='submit'>{intl().formatMessage(messages.Next)}</Button>
                </Form.Item>
              </Form>
            </Flex>
          </Drawer>
          <Drawer
            visible={isCalledDeeplink}
            height='300px'
            className={classes.calledDeepLinkDrawer}
            closable={false}
            placement='bottom'
          >
            <Flex direction='column' className='h-full'>
              <Flex.Item>
                <div>
                  <Flex direction='column' justify='center' className='text-center'>
                    <div className={classes.circleShadow}>
                      <Spin
                        spinning={isCalledDeeplink}
                        className={classes.spin}
                        indicator={
                          <Icon type='loading' style={{ fontSize: 60 }} spin />
                        }
                      />
                    </div>
                    <WhiteSpace size='xl' />
                    {intl().formatMessage(messages.Processing)}
                    <WhiteSpace size='sm' />
                    <div className='paragraph_regular text_secondary'>
                      {`${intl().formatMessage(messages.ProcessingDescription)}`}&nbsp;*
                      <i className='text_main paragraph_regular'>
                        {intl().formatMessage(messages.HighlightAaniPayName)}
                      </i>
                        *
                    </div>
                  </Flex>
                </div>
                <WhiteSpace size='xl' />
                <WhiteSpace size='sm' />
              </Flex.Item>
              <div className='w-full'>
                <Button
                  block
                  type='primary'
                  style={{ backgroundColor: 'var(--brand-color-2)' }}
                  size='large'
                  onClick={() => {
                    pageName &&
                        recordCountlyEvent({
                          page_name: pageName,
                          event_name: 'click',
                          element_name: 'retry',
                          biz_tags: {
                            trade_voucher_no: sessionStorage.orderNo,
                          },
                        })
                    this.setState({ isCalledDeeplink: false })
                  }}
                >
                  <span>{intl().formatMessage(messages.TryAgain)}</span>
                </Button>
              </div>
            </Flex>
          </Drawer>
        </div>
      )
    }
    return (
      <div className={classes.componentsPaymentMethodsAaniPay}>
        {(isErr || scanPayUrl) && (
          <div className={isErr ? classes.logoFaild : classes.logoPc}>
            {
              !isErr ? (
                <img src={IMAGES.ImageLogoPc} />
              ) : <img src={IMAGES.ImageFaild} />
            }
          </div>
        )}
        {isErr ? (
          <ErrorPrompt onTryAgain={this.retryGetQR} />
        ) : (
          scanPayUrl && (
            <div style={{ position: 'relative', display: 'inline-block' }}>
              <svg width='0' height='0' style={{ position: 'absolute' }}>
                <defs>
                  <linearGradient id='aaniQrGradient' x1='10%' y1='0%' x2='90%' y2='100%'>
                    <stop offset='0%' stopColor='#43C6AC' />
                    <stop offset='100%' stopColor='#191654' />
                  </linearGradient>
                </defs>
              </svg>
              <QRCodeManager
                renderAs='svg'
                size={232}
                value={scanPayUrl}
                bgColor='transparent'
                fgColor='url(#aaniQrGradient)'
                level='H'
              />
            </div>
          )
        )}
        {!isErr && !scanPayUrl && (
          <div style={{
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '300px'
          }}
          >
            <Spin
              size='large'
              indicator={<Icon type='loading' style={{ fontSize: 48, color: '#011FE5' }} spin />}
            />
            <p style={{ marginTop: '24px', fontSize: '16px', fontWeight: '600' }}>{intl().formatMessage(messages.GeneratingQRCode)}</p>
          </div>
        )}
        {!isErr && scanPayUrl && (
          <div className='text_secondary' style={{ lineHeight: '24px', marginTop: '16px' }}>
            <span className='iconfont iconSCANPAY font-24' style={{ verticalAlign: 'bottom' }} />{' '}
            {intl().formatMessage(messages.ScanandPayWith)}
          </div>
        )}
      </div>
    )
  }
}

export default connect(
  (state) => ({
    siteConfig: state.siteConfig,
  }),
  {}
)(Form.create()(AaniPay))
